import * as React from 'react';
import './ForgotUserId.scss';
import Input from 'src/components/common/Input';
import Button from 'src/components/common/Button';
import Alert from './../../../ForgotPasswordView/components/Alert';
import UserService from 'src/services/user/userService';
import Loader from 'src/components/common/Loader';
import { goToHome } from 'src/utils/navigation';

enum ForgotUserIdState {
  Forgot,
  Success
}

enum AlertType {
  NotFound,
  Error,
  Success
}

interface IForgotUserIdState {
  loading: boolean;
  input: string;
  state: ForgotUserIdState;
  showAlert: boolean;
  alertType: AlertType;
}

export class ForgotUserId extends React.Component<any, IForgotUserIdState> {
  public state: IForgotUserIdState = {
    loading: false,
    input: '',
    state: ForgotUserIdState.Forgot,
    showAlert: false,
    alertType: AlertType.Success
  };

  private setStateProm = (newState: any): Promise<void> => {
    return new Promise((resolve, _) => {
      this.setState(newState, () => resolve());
    });
  };

  private handleInput = (value: string) => {
    this.setState({ input: value });
  };

  private handleCloseAlert = () => {
    this.setState({ showAlert: false });
  };

  private handleSubmitForgot = async () => {
    await this.setStateProm({ loading: true, showAlert: false });
    UserService.forgotUserId(this.state.input)
      .then(() => {
        this.setState({
          loading: false,
          state: ForgotUserIdState.Success,
          showAlert: true,
          alertType: AlertType.Success
        });
      })
      .catch(err => {
        console.error(err);
        this.setState({
          loading: false,
          showAlert: true,
          alertType: AlertType.NotFound
        });
      });
  };

  private handleInputEnter = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      this.handleSubmitForgot();
    }
  };

  private renderForgot() {
    return (
      <div className="rp-forgotuserid--container">
        <h1>Retrieve User ID</h1>
        <p className="rp-forgotuserid--p">
          Enter the email address you used to request your account and we'll
          send your registered user ID.
        </p>
        <Input
          label="Email Or Mobile Phone Number:"
          onChange={this.handleInput}
          value={this.state.input}
          className="rp-forgotuserid--input"
          onKeyDown={this.handleInputEnter}
        />
        <Button
          label="Send"
          textTransform="uppercase"
          buttonClass="primary-button rp-forgotuserid--button"
          height="48px"
          action={this.handleSubmitForgot}
          disabled={!this.state.input.length}
        />
      </div>
    );
  }

  private renderSuccess() {
    return (
      <div className="rp-forgotuserid--container">
        <h1>Retrieve User ID</h1>
        <p className="rp-forgotuserid--p">
          Your User ID has been sent to the email or mobile phone number
          specified.
        </p>

        <Button
          label="Go to Home"
          textTransform="uppercase"
          buttonClass="primary-button rp-forgotuserid--button"
          height="48px"
          action={goToHome}
        />
      </div>
    );
  }

  private renderAlert() {
    const type = this.state.alertType;
    return type === AlertType.NotFound ? (
      <Alert
        type="error"
        children={
          <span>
            This email or phone number is not registered. Please contact{' '}
            <b>Customer Support</b>.
          </span>
        }
        icon="rpds-error"
        onClose={this.handleCloseAlert}
      />
    ) : type === AlertType.Error ? (
      <Alert
        type="error"
        children={
          <span>
            There was an error, please try again later or contact support.
          </span>
        }
        icon="rpds-error"
        onClose={this.handleCloseAlert}
      />
    ) : type === AlertType.Success ? (
      <Alert
        type="success"
        children={
          <span>
            <b>User ID Sent</b>. Please check your inbox.
          </span>
        }
        icon="rpds-check-circle"
        onClose={this.handleCloseAlert}
      />
    ) : null;
  }

  public render() {
    const state = this.state.state;
    return (
      <div className="rp-forgotuserid">
        {this.state.loading ? <Loader /> : null}
        <div className="rp-forgotuserid--alert">
          {this.state.showAlert ? this.renderAlert() : null}
        </div>
        <div className="rp-forgotuserid--content">
          {state === ForgotUserIdState.Forgot
            ? this.renderForgot()
            : state === ForgotUserIdState.Success
            ? this.renderSuccess()
            : null}
        </div>
      </div>
    );
  }
}
